import { eFontAsset, Game } from "../Game";
import { PopupMessageBase, PopupMessageType } from "../Utils/PopupMessage";
import { IUpdatableItem } from "../Utils/UpdatableItems";
import { TIMER } from "./Gameplay";



interface TextPopupColor {
    color: pc.Color;
    outlineColor: pc.Color;
    shadowColor: pc.Color;
}



export class TextPopup extends PopupMessageBase implements IUpdatableItem {
    private static readonly COLORS: TextPopupColor[] = [
        {
            color: new pc.Color(1, 1, 1),
            outlineColor: new pc.Color().fromString("#0B2343FF"),
            shadowColor: new pc.Color().fromString("#0B2343FF")
        },
        {
            color: new pc.Color(1, 1, 1),
            outlineColor: new pc.Color().fromString("#430b23"),
            shadowColor: new pc.Color().fromString("#430b23")
        }
    ];

    private static _msgType: PopupMessageType;

    private _entity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super();

        if (!TextPopup._msgType)
            TextPopup._msgType = new PopupMessageType(new pc.Vec3(0, 1.25, 0), 1250, pc.CubicIn, 750, 500, pc.CubicIn);

        this._entity = new pc.Entity("textPopup");
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            fontSize: 0.4,
            fontAsset: Game.app.assets.find(eFontAsset.default, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
            pivot: [0.6, 0],
            color: new pc.Color(1, 1, 1),
            outlineThickness: 0.5,
            outlineColor: new pc.Color().fromString("#0B2343FF"),
            shadowOffset: [0.5, -0.5],
            shadowColor: new pc.Color().fromString("#0B2343FF")
        });

        Game.app.root.addChild(this._entity);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(x: number, y: number, z: number, text: string, colorId: number = 0): TextPopup {
        let element = this._entity.element;
        let color = TextPopup.COLORS[colorId];

        element.color = color.color;
        element.outlineColor = color.outlineColor;
        element.shadowColor = color.shadowColor;
        element.text = text;
        element.enabled = true;

        this._entity.setLocalScale(1, 1, 1);
        super.showMessage(x, y, z, TextPopup._msgType, TIMER);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        return super.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): IUpdatableItem {
        super.release();
        this._entity.element.enabled = false;

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateContainer(pos: pc.Vec3, opacity: number): void {
        let scale = 0 + pc.BounceOut(Math.min(0.5, this._progress) / 0.5) * 1.25;

        this._entity.setLocalScale(scale, scale, scale);
        this._entity.setPosition(pos);
        this._entity.element.opacity = opacity;
    }
}